import React, { useEffect } from "react";
import "./assets/vendors/bootstrap/css/bootstrap.min.css";
import "./assets/vendors/animate/animate.min.css";
import "./assets/vendors/fontawesome/css/all.min.css";
import "./assets/vendors/jarallax/jarallax.css";
import "./assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css";
import "./assets/vendors/nouislider/nouislider.min.css";
import "./assets/vendors/odometer/odometer.min.css";
import "./assets/vendors/swiper/swiper.min.css";
import "./assets/vendors/pifoxen-icons/style.css";
import "./assets/vendors/tiny-slider/tiny-slider.min.css";
import "./assets/vendors/owl-carousel/owl.carousel.min.css";
import "./assets/vendors/bxslider/jquery.bxslider.css";
import "./assets/vendors/bootstrap-select/css/bootstrap-select.min.css";
import "./assets/vendors/vegas/vegas.min.css";
import "./assets/vendors/jquery-ui/jquery-ui.css";
import "./assets/vendors/timepicker/timePicker.css";

import "./assets/css/pifoxen.css";
import "./assets/css/pifoxen-responsive.css";
import "./assets/custom-css/custom.css";
import Main from "./routes/Main";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import MobileNav from "./components/MobileNav";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { Element } from "react-scroll";
import { fetchCompanyDetails } from "./api/CompanyDetailsApi";
import { dynamicFailed } from "./hooks/useToast";
import { useCompanyDetailsContext } from "./context/CompanyDetailsContext";
import { useUserDataContext } from "./context/UserDataContext";
import { checkUser } from "./api/UserApi";
import AdminSideBar from "./components/AdminSideBar";
import MemberSideBar from "./components/MemberSideBar";
import UserMenu from "./components/UserMenu";
import { fetchMemberLists, getToken } from "./api/MemberApi";
import axios from "axios";
import { headers } from "./exports/exports";

const MainPage = () => {
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();
  const { userData, setUserData } = useUserDataContext();
  useEffect(() => {
    Promise.all([fetchMemberLists(), getToken()])
      .then(async ([listMemberData, tokenData]) => {
        const today = new Date();
        const sisheaders = {
          Authorization: `Bearer ${tokenData[0]?.attributes?.Token}`,
        };

        const expiredMembers = listMemberData?.filter((user: any) => {
          const expiry = user.attributes.Membership_Expiry;
          if (!expiry) return false;
          const expiryDate = new Date(expiry);
          return expiryDate < today && user.attributes.Status !== "Expire";
        });

        for (const member of expiredMembers) {
          const locationDetail = {
            area_name: "Chhauni",
            street_name: "Kakancho Binayak Marg",
            nearest_landmark: "",
            municipalities_id: 332,
            district_id: 28,
            province_id: 3,
          };

          const res = await axios.post(
            `${process.env.REACT_APP_locationUrl}/location`,
            locationDetail,
            {
              headers: sisheaders,
            }
          );
          if (res?.status === 200 || res?.status === 201) {
            const userDetail = {
              name: member?.attributes?.First_Name,
              phone_no: member?.attributes?.Mobile_Number,
              address: JSON.stringify({
                area_name: { id: res?.data?.area_id },
                street_name: { id: res?.data?.street_id },
                nearest_landmark: "",
                municipalities_id: 332,
                district_id: 28,
                province_id: 3,
              }),
              email: member?.attributes?.Email,
              gender: member?.attributes?.Sex === "Male" ? 1 : 2,
              dob: "2000-01-01T00:00:00+05:45",
              //   password: password,
              //   password_confirmation: reenterPassword,
              status: 0,
              roles: ["member"],
              profile_pic: null,
            };
            const userUpRes = await axios.put(
              `${
                process.env.REACT_APP_IDENTITY_SERVER_URL
              }api/admin/users/${Number(member?.attributes?.sis_id)}`,
              userDetail,
              {
                headers: sisheaders,
              }
            );
            if (userUpRes?.data?.status === "success") {
              const data = {
                data: {
                  Status: "Expire",
                },
              };

              try {
                await axios.put(
                  `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${member.id}`,
                  data,
                  {
                    headers: headers,
                  }
                );
              } catch (error) {
                console.error(`Failed to update user ID ${member.id}:`, error);
              }
            }
          }
        }
      })
      .catch(() => {
        dynamicFailed("Server Error");
      });
  }, []);
  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([CompanyDetailsData]) => {
          setCompanyDetailsData(CompanyDetailsData);
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);
  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);
  const userPage =
    window.location.pathname.includes("admin/") ||
    window.location.pathname.includes("member/");
  const adminPaths = [
    "/admin/dashboard",
    "/admin/members",
    "/admin/affliliates",
    "/admin/members/edit",
  ];

  const memberPaths = ["/member/dashboard", "/member/profile"];

  const pathname = window.location.pathname;

  const admin = adminPaths.some((path) => pathname.includes(path));
  const member = memberPaths.some((path) => pathname.includes(path));
  return (
    <>
      {/* <body> */}
      <div className="page-wrapper">
        <Element name="toTop"></Element>
        <header className="main-header-two clearfix">
          <Header />
          {!userPage && <Menu />}
        </header>
        {userPage && <UserMenu />}
        <Main />
        {!userPage && <Footer />}
      </div>
      <MobileNav />
      {admin && <AdminSideBar />}
      {member && <MemberSideBar />}
      <ScrollToTop />
      {/* </body> */}
      <Loader />
    </>
  );
};

export default MainPage;
